import get from 'lodash/get';
import invert from 'lodash/invert';
import { labels } from '../../constants/analytics/categoryActionLabel/subscribe';

export default function getSubscribeEventLabel(label, location) {
  const querySource = get(location, 'query.source');
  const isDuplicate = invert(labels)[querySource];
  return querySource && !isDuplicate ? `${label}.${querySource}` : label;
}
